import * as React from 'react'
import {connect} from 'react-redux'
import {Container, Modal, ModalBody, ModalHeader} from 'reactstrap'
import {Loading} from '../../../components/loading'
import * as Actions from './actions'
import './styles.css'

export const PreviewNewsbrief = (props: any) => {
  return (
    <Modal onOpened={() => props.getEmailTemplate(props.emailTemplate, props.communityIdentifier, props.content)}
           className="modal-lg extra-width-container"
           isOpen={props.isModalOpen}
           toggle={props.toggle}>
      {/* TODO: ModalHeader complains if you pass in props.emailTemplate for title text.
        Changing to Template Preview to supress warning for the moment*/}
      <ModalHeader toggle={props.toggle}>Template Preview</ModalHeader>
      <ModalBody>
        <Container>
          {props.isFetchingPreview && <Loading center size={Loading.Sizes.LARGE} top={0} />}
          {props.isShowingPreview ? <div dangerouslySetInnerHTML={{__html: props.previewHtml}}/> : null}
        </Container>
      </ModalBody>
    </Modal>
  );
}

export const PreviewNewsbriefConnected = connect(
  ({previewNewsbrief}: any) => ({...previewNewsbrief}),
  {
    getEmailTemplate: Actions.getEmailTemplate,
    toggle: Actions.toggleModalHeader,
  },
)(PreviewNewsbrief)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/preview-newsbrief/component.tsx